import ChartCard from "./ChartCard";
import { PieChart1 } from "./PieChart1";
import { useEffect, useState, useRef } from "react";
import { Pie } from "react-chartjs-2";
import classes from "./ChartDisplayArea.module.css";

import BarChart from "./BarChart";
import { ratingBarGraph } from "../util/ratingBarGraph";
import {
  genPieChartData1,
  pieChartPercentageCalculator,
} from "../util/genPieChartData1";
import { getActiveBranchIds } from "../util/multipleBranch/getActiveBranchId";
import { lineChartForBranches } from "../util/adminDashboard/lineChartForBranches";
import LineChartForBranches from "./LineChartForBranches";

export default function ChartDisplayArea1({ data, qdata }) {
  // console.log("inside Cda");
  // use reducer functions to convert data to representable data points

  //   const bIds = getActiveBranchIds(JSON.parse(localStorage.getItem("branches")));
  // console.log(data);

  if (data == undefined || data.length == 0 || data == null) {
    return "No Data";
  }
  let activeBranches = getActiveBranchIds(
    JSON.parse(localStorage.getItem("branches"))
  );
  // console.log(activeBranches);

  let numOfBranches = activeBranches.length;
  let barData;
  let lineChartData;
  if (numOfBranches == 1) {
    barData = ratingBarGraph(10, data);
    // console.log(barData);
  } else {
    lineChartData = lineChartForBranches(10, data);
  }

  const newPieData = genPieChartData1(data);
  // console.log(newPieData);

  return (
    <div className={classes.container}>
      <h1>Charts </h1>
      {/* <div className={classes.chartsControllerContainer}></div> */}

      <div className={classes.innerContainer}>
        {barData && numOfBranches == 1 && (
          <div className={classes.barChartContainer}>
            <BarChart data={barData} />
          </div>
        )}

        {numOfBranches > 1 && (
          <div className={classes.lineChartContainer}>
            <LineChartForBranches data={lineChartData} />
          </div>
        )}
        {newPieData && (
          <div className={classes.pieChartContainer} id={"myPie"}>
            <PieChart1 data1={newPieData} />
          </div>
        )}
      </div>
    </div>
  );
}
